export default "__VITE_ASSET__DXhuDk76__"